import { AnalyticsProductClickObjectException } from '../errors/analyticsError';
import Logger from '../utils/analyticsLogger';
import DataObject from './DataObject';
import ProductObject from './ProductObject';

export default class ProductClickObject extends DataObject {
  constructor(data) {
    super('productClick', data);

    if (data.currency) {
      this.currency = data.currency;
    }

    this.name = 'select_item';
    if (data.name) {
      this.name = data.name;
    }

    if (data.product_info) {
      this.product_info = data.product_info;
    }

    if (!data.products || data.products.length === 0) {
      Logger.error(
        '[AnalyticsProductClickObjectException] Product is required for productClick',
        data,
      );
      throw new AnalyticsProductClickObjectException('Product is required for productClick');
    }
  }

  initEcommerce() {
    this.result.ecommerce = this.result.ecommerce || {};
    this.result.ecommerce.click = this.result.ecommerce.click || {};
    this.result.event_name = 'select_item';
  }

  set category(category) {
    if (category !== 'Ecommerce') {
      this.result.eventCategory = this.setProperty(category);
    } else {
      this.result.eventCategory = 'Ecommerce';
    }
  }

  get category() {
    return this.result.eventCategory;
  }

  set action(action) {
    this.result.eventAction = this.setProperty(action);
  }

  get action() {
    return this.result.eventAction;
  }

  set label(value) {
    this.result.eventLabel = this.setProperty(value);
  }

  get label() {
    return this.result.eventLabel;
  }

  set product_info(value) {
    this.result.product_info = this.setProperty(value);
  }

  set currency(currency) {
    this.result.currencyCode = this.setProperty(currency, false);
  }

  set name(name) {
    this.result.event_name = this.setProperty(name, false);
  }

  set value(value) {
    this.result.eventValue = this.setProperty(value);
  }

  set products(products) {
    Object.keys(products).forEach(function (key) {
      if (!products[key].price) {
        products[key].price = 'none';
      }
    });
    products = products.map((product) => new ProductObject(product).toObject());

    this.initEcommerce();

    this.result.ecommerce.click.products = products;
  }

  get products() {
    return (this.result.ecommerce && this.result.ecommerce.click.products) || [];
  }

  set list(list) {
    this.initEcommerce();

    this.result.ecommerce.click.actionField = { list: this.setProperty(list) };
  }
}
